"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var config_1 = require("../constants/config");
var Icon_1 = __importDefault(require("./Icon"));
var ProfileImage_1 = __importDefault(require("./ProfileImage"));
// 알림 항목 아이콘 출력
function Profile(_ref) {
  var type = _ref.type,
    id = _ref.id;
  var link = (0, hooks_1.useMemo)(function () {
    if (id === "afsysop") {
      return "javascript:;";
    }
    return "".concat(config_1.BJ_AFREECA_DOMAIN, "/").concat(id);
  }, [id]);
  return (0, preact_1.h)("a", {
    href: link,
    className: "profile",
    target: "_top"
  }, (0, preact_1.h)(ProfileImage_1.default, {
    id: id
  }), (0, preact_1.h)(Icon_1.default, {
    type: type
  }));
}
exports.default = Profile;